"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outline = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var measure_unit_1 = require("./measure-unit");
exports.outline = type_guard_1.object({
    props: {
        width: measure_unit_1.measureUnit,
        offset: type_guard_1.optional(type_guard_1.defaulted(measure_unit_1.measureUnit, '0px')),
        style: type_guard_1.optional(type_guard_1.defaulted(type_guard_1.enums(['none', 'dotted', 'dashed', 'solid']), 'solid'))
    }
});
